import { ALLOWED_TIME_SIGNATURES } from './tuneTimeSignatures';

/**
 * Preset options for tune metadata dropdowns (page editor, admin tune metadata, etc.).
 * Users can add values not in the list via "+ Add new entry…" (except time_signature).
 * Admin can edit lists at /admin/templates → Tune options tab (saved in website_settings).
 */
export const DEFAULT_TUNE_METADATA_FIELD_OPTIONS = {
  region: [
    'Cape Breton',
    'Scottish',
    'Irish',
    'Nova Scotian',
    'Nova Scotia',
    'Shetland',
    'Glengarry',
    'Celtic',
    'Irish Traditional',
    'Scottish Traditional',
    'Cape Breton Scottish',
    'Breton',
  ],
  tune_type: [
    'Reel',
    'Jig',
    'Strathspey',
    'March',
    'Air',
    'Slow Air',
    'Hornpipe',
    'Waltz',
    'Polka',
    'Slide',
    'Cape Breton Jig',
    'Cape Breton Reel',
    'Pipe March',
    'Pipe Reel',
    '6/8 March',
    'Breakdown',
    'Schottische',
  ],
  key_signature: [
    'A Major',
    'A Minor',
    'B Minor',
    'D Major',
    'E Minor',
    'G Major',
    'F Major',
    'C Major',
    'G Minor',
    'D Minor',
    'F# Minor',
    'E Major',
    'B Major',
    'C# Minor',
    'F# Major',
    'Bb Major',
    'Mixolydian',
  ],
  time_signature: [...ALLOWED_TIME_SIGNATURES],
};

/** @deprecated use DEFAULT_TUNE_METADATA_FIELD_OPTIONS or fetchTuneSiteOptions() */
export const TUNE_METADATA_FIELD_OPTIONS = DEFAULT_TUNE_METADATA_FIELD_OPTIONS;

const FIELD_KEYS = ['region', 'tune_type', 'key_signature', 'time_signature'];

/** Merge admin overrides onto built-in defaults (per-field replace when non-empty). */
export function mergeTuneMetadataFieldOptions(overrides) {
  const merged = {};
  for (const key of FIELD_KEYS) {
    const custom = overrides && overrides[key];
    if (Array.isArray(custom) && custom.length > 0) {
      const seen = new Set();
      merged[key] = [];
      for (const raw of custom) {
        const s = String(raw || '').trim();
        if (!s) continue;
        const k = s.toLowerCase();
        if (seen.has(k)) continue;
        seen.add(k);
        merged[key].push(s);
      }
    } else {
      merged[key] = [...DEFAULT_TUNE_METADATA_FIELD_OPTIONS[key]];
    }
  }
  return merged;
}
